import AuthLayout from "@/layout/auth/authLayout";
import { RouteObject } from "react-router-dom";
import ForgetPasswordCheckOtp from "./forgetPasswordCheckOtp";
import ForgetPasswordPhoneNumber from "./forgetPasswordPhoneNumber";
import Login from "./login";
import ResetPassword from "./resetPassword";
import SignUp from "./signUp";

import Verification from "./Verification";
import SignUpMerchantUser from "./signUpMerchantUser";
import Welcome from "./welcome";
import MagicLogin from "./magic";

export const AuthRoutes: RouteObject[] = [
  {
    path: "auth",
    element: <AuthLayout />,
    errorElement: <>error page</>,
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "signUp",
        element: <SignUp />,
      },
      {
        path: "forgetPasswordPhoneNumber",
        element: <ForgetPasswordPhoneNumber />,
      },
      {
        path: "forgetPasswordCheckOtp",
        element: <ForgetPasswordCheckOtp />,
      },
      {
        path: "resetPassword",
        element: <ResetPassword />,
      },
      {
        path: "verification",
        element: <Verification />,
      },
    ],
  },
  {
    path: "auth",
    errorElement: <>error page</>,
    children: [
      {
        path: "signUpMerchantUser",
        element: <SignUpMerchantUser />,
      },
      {
        path: "welcome",
        element: <Welcome />,
      },
      { path: "magic", element: <MagicLogin /> },
    ],
  },
];
